<template>
  
  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      Filtrar Solicitações de Complemento de Laudos
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Data Inicial</label>
            <date-picker ref="startDatePicker" @onChange="onChangeStartDate" />
          </div>         
          <div class="eight wide field">
            <label class="form-label">Data Final</label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>                          
        </div>        
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Status</label>
            <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
          </div>
          <div class="eight wide field">
            <label class="form-label">Solicitante</label>
            <input type="text" v-model="filter.requesterName">
          </div> 
        </div>
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Responsável</label>
            <input type="text" v-model="filter.responsibleName">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CertComplementRequestService from "@/services/cert-complement-request-service"
  import modalDialog from "@/mixins/modal-dialog"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "CertComplementRequestsFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    methods: {      

      onShow() {
        this.emitEvent = null
        this.initFilter()
        this.loadDatePickers()
        this.loadStatusDropdown()
      }, 

      initFilter() {

        if (this.$store.state.pages.filters.certComplementRequests) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.certComplementRequests)

        } else {          

          this.showRemoveButton = false
          this.filter = { startDate: null, endDate: null, status: "*" }
        }        
      },

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })

        if (this.filter.startDate && this.filter.endDate) {
          this.$refs.startDatePicker.setDate(this.filter.startDate)
          this.$refs.endDatePicker.setDate(this.filter.endDate)
        }        
      },

      loadStatusDropdown() {
        
        let statusList = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]        
        const REQUEST_STATUS = CertComplementRequestService.STATUS

        for (let prop in REQUEST_STATUS) {
          if (REQUEST_STATUS.hasOwnProperty(prop)) {
            statusList.push({
              id: prop,
              value: `<i class="${REQUEST_STATUS[prop].icon}"></i> ` + REQUEST_STATUS[prop].description
            })
          }
        }

        this.$refs.statusDropdown.setValues(statusList, this.filter.status)
      },      

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()          
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      onChangeStatus(status) {
        this.filter.status = status
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        if (!this.validDates())
          return

        this.updateStore(this.filter)

        let data = this.$cloneObject(this.filter)

        if (data.startDate && data.endDate) {
          data.startDate = moment(data.startDate).format("YYYY-MM-DD")
          data.endDate = moment(data.endDate).format("YYYY-MM-DD")
        }        
        
        this.emitEvent = { event: "onApply", data }

        this.hide()        
      },

      validDates() {

        let isOk = true
        let message = ""

        if (this.filter.startDate && !this.filter.endDate) {
          message = "Informe a data final"
        } else if (this.filter.endDate && !this.filter.startDate) {
          message = "Informe a data inicial"            
        } 

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.certComplementRequests = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>